import React, { Component } from 'react';

import moment from 'moment';

import GoalsContestsService from '../../services/GoalsContestsService';

import SettingsCardHeader from './SettingsCardHeader';
import ContestResultItem from './ContestResultItem';


export default class ContestsViewResults extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            contestResults: []
        }

        this.gcService = new GoalsContestsService();
        this.cnt = ['One', 'Two', 'Three'];

        this.saveContestResult = this.saveContestResult.bind(this);

        this.generateContestItems = this.generateContestItems.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    saveContestResult(contestResult, callback) {
        let self = this;

        let tempResult = {
            contestResultId: contestResult.contestResultId,
            contestId: contestResult.contestId,
            userId: contestResult.userId,
            rank: contestResult.rank,
            finalTicketCount: contestResult.finalTicketCount,
            createdBy: contestResult.createdBy,
            createDate: contestResult.createDate,
            winnerName: contestResult.winnerName,
            secondName: contestResult.secondName,
            thirdName: contestResult.thirdName,
            calStart: contestResult.calStart,
            calEnd: contestResult.calEnd
        }

        this.props.saveContestResult(tempResult, callback)
    }

    generateContestItems() {
        let self = this;

        let identity = this.props.identity;

        let contestPeriods = [];

        let resultsData = identity.contestResults.reduce((r, e) => {
            let key = moment(e.calStart).format("YYYYMMDD") + '|' + e.contestId;
            if (!r[key]) {
                r[key] = e;
            } else {

            }
            return r;
        }, {});

        let multiStoreBlastData = Object.values(identity.blastData.reduce((r, e) => {

            let key = e.name + "|" + e.dateIndex + "|" + e.goalContestReportKpi.reportKpiId;
            if (!r[key]) {
                r[key] = {
                    contestId: identity.contestId,
                    calEnd: e.calEnd,
                    calStart: e.calStart,
                    cyValue: e.cyValue,
                    date: e.date,
                    dateIndex: e.dateIndex,
                    goalContestReportKpi: e.goalContestReportKpi,
                    id: e.id,
                    locationId: e.locationId,
                    lyValue: e.lyValue,
                    name: e.name,
                    type: e.type,
                    userId: e.userId
                }
            } else {
                r[key].lyValue += e.lyValue;
                r[key].cyValue += e.cyValue;
                r[key].locationId = 'multi';
            }
            return r;
        }, {}));

        let periodData = Object.values(multiStoreBlastData.reduce((r, e) => {
            let key = moment(e.calStart.substring(0, e.calStart.length - 1)).format("YYYYMMDD") + '|' + e.contestId;
            if (!r[key]) {
                r[key] = {
                    key: key,
                    calStart: e.calStart,
                    calEnd: e.calEnd,
                    winnerName: resultsData[key] != undefined ? resultsData[key].winnerName : null,
                    secondName: resultsData[key] != undefined ? resultsData[key].secondName : null,
                    thirdName: resultsData[key] != undefined ? resultsData[key].thirdName : null,
                    contestResultId: resultsData[key] != undefined ? resultsData[key].contestResultId : null,
                    finalTicketCount: resultsData[key] != undefined ? resultsData[key].finalTicketCount : null,
                    contestId: identity.contestId,
                    contestType: identity.contestType,
                    kpiIdOne: identity.reportKPIIdOne,
                    kpiIdTwo: identity.reportKPIIdTwo,
                    kpiIdThree: identity.reportKPIIdThree,
                    kpiValueOne: identity.valueOne,
                    kpiValueTwo: identity.valueTwo,
                    kpiValueThree: identity.valueThree,
                    kpiUnderOne: identity.useUnderOne,
                    kpiUnderTwo: identity.useUnderTwo,
                    kpiUnderThree: identity.useUnderThree,
                    kpiIdMinOne: identity.reportKPIIdMinOne,
                    kpiIdMinTwo: identity.reportKPIIdMinTwo,
                    kpiIdMinThree: identity.reportKPIIdMinThree,
                    kpiValueMinOne: identity.valueMinOne,
                    kpiValueMinTwo: identity.valueMinTwo,
                    kpiValueMinThree: identity.valueMinThree,
                    kpiUnderMinOne: identity.useUnderMinOne,
                    kpiUnderMinTwo: identity.useUnderMinTwo,
                    kpiUnderMinThree: identity.useUnderMinThree,
                    type: identity.type,
                    blastData: [{
                        cyValue: e.cyValue,
                        dateIndex: e.dateIndex,
                        goalContestReportKpi: e.goalContestReportKpi,
                        locationId: e.locationId,
                        lyValue: e.lyValue,
                        name: e.name,
                        type: e.type,
                        userId: e.userId
                    }]
                };
            } else {
                r[key].blastData.push({
                    cyValue: e.cyValue,
                    dateIndex: e.dateIndex,
                    goalContestReportKpi: e.goalContestReportKpi,
                    locationId: e.locationId,
                    lyValue: e.lyValue,
                    name: e.name,
                    type: e.type,
                    userId: e.userId
                });
            }
            return r;
        }, {}));

        periodData = _.sortBy(periodData, (obj) => { return parseInt(moment(new Date(obj.calStart)).format('YYYYMMDD')) })

        periodData.forEach((p) => {
            let pDat = p;

            let pContestResult = resultsData[pDat.key];
            pDat.createdBy = this.props.accountInfo.userName;
            pDat.createDate = moment().format("MM/DD/YYYY");

            contestPeriods.push((<ContestResultItem
                identity={pDat}
                isCompetition={identity.contestType === 'Competition'}
                saveContestResult={this.saveContestResult}
            />));
        });

        return contestPeriods;
    }

    render() {

        if (this.props.identity === undefined || this.props.identity === null) {
            return (
                <div className={this.props.className} style={this.props.style}>
                    <div className={"settings-central-regular-card-container"}>
                    </div>
                </div>
            );
        }

        let contestItems = this.generateContestItems();

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className={"settings-central-regular-card-container"} style={{ lineHeight: 1 }}>
                    <SettingsCardHeader
                        title={this.props.identity.name}
                        subtitle={this.props.identity.description}
                    />
                    <div class="main-outer">
                        {contestItems}
                    </div>
                </div>
            </div>
        );
    }
}